import http from "../../services/http";
import * as types from "../types/fidelidade_resumo";
import queryString from "querystring";

export const loadRankingCashback = (filtro) => {
  return (dispatch) => {
    const qry = queryString.stringify(filtro, { arrayFormat: "index" });
    dispatch({ type: types.FIDELIDADE_RESUMO_LOADING, payload: true });
    http.get(`/api/v2/empresa/fidelidade/resumo/cashback?${qry}`).then(
      (response) => {
        dispatch([
          {
            type: types.FIDELIDADE_RESUMO_RANKING_CASHBACK,
            payload: response.data,
          },
          { type: types.FIDELIDADE_RESUMO_LOADING, payload: false },
        ]);
        dispatch({ type: types.FIDELIDADE_RESUMO_LOADING, payload: false });
      },
      (error) => {
        console.log(error);
      }
    );
  };
};

export const loadRankingTransacoes = (filtro) => {
  return (dispatch) => {
    const qry = queryString.stringify(filtro, { arrayFormat: "index" });
    dispatch({ type: types.FIDELIDADE_RESUMO_LOADING, payload: true });
    http.get(`/api/v2/empresa/fidelidade/resumo/transacoes?${qry}`).then(
      (response) => {
        dispatch([
          {
            type: types.FIDELIDADE_RESUMO_RANKING_TRANSACOES,
            payload: response.data,
          },
          { type: types.FIDELIDADE_RESUMO_LOADING, payload: false },
        ]);
        dispatch({ type: types.FIDELIDADE_RESUMO_LOADING, payload: false });
      },
      (error) => {
        console.log(error);
      }
    );
  };
};

export const loadRankingAniversariantes = (filtro) => {
  return (dispatch) => {
    dispatch({ type: types.FIDELIDADE_RESUMO_LOADING, payload: true });
    http.get(`/api/v2/empresa/fidelidade/resumo/aniversariantes`).then(
      (response) => {
        dispatch([
          {
            type: types.FIDELIDADE_RESUMO_RANKING_ANIVERSARIANTES,
            payload: response.data,
          },
          { type: types.FIDELIDADE_RESUMO_LOADING, payload: false },
        ]);
        dispatch({ type: types.FIDELIDADE_RESUMO_LOADING, payload: false });
      },
      (error) => {
        console.log(error);
      }
    );
  };
};

export const loadRankingVencimentos = (filtro) => {
  return (dispatch) => {
    dispatch({ type: types.FIDELIDADE_RESUMO_LOADING, payload: true });
    http.get(`/api/v2/empresa/fidelidade/resumo/vencimentos`).then(
      (response) => {
        dispatch([
          {
            type: types.FIDELIDADE_RESUMO_RANKING_VENCIMENTOS,
            payload: response.data,
          },
          { type: types.FIDELIDADE_RESUMO_LOADING, payload: false },
        ]);
        dispatch({ type: types.FIDELIDADE_RESUMO_LOADING, payload: false });
      },
      (error) => {
        console.log(error);
      }
    );
  };
};
